import React from 'react';
import ProfileDetailsComponent from '../components/ProfileDetails';

const Details: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <ProfileDetailsComponent />
    </div>
  );
};

export default Details;